import { PathStopAPI } from '../../../api/datamanager/PathStopAPI';

export class PathStopsDraftCommand {
    getByPath(edition, pathId, providerId, successCallback, errorCallback) {
        const apiResult = PathStopAPI.listByPathDraft(edition.draftNetwork, pathId, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    save(edition, pathStop, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === pathStop.id || 0 === pathStop.id) {
            apiResult = PathStopAPI.createDraftSingle(edition.draftNetwork, pathStop);
            successMessage = "[Rascunho] Paragem do Percurso criada com sucesso";
        }
        else {
            apiResult = PathStopAPI.updateDraft(edition.draftNetwork, pathStop.id, pathStop);
            successMessage = "[Rascunho] Paragem do Percurso editada com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    createInBulk(edition, pathStopsDraft, successCallback, errorCallback) {
        const newPathStops = pathStopsDraft.map(pathStop => {
            return {
                id: 0,
                networkEdition: pathStop.path.networkEdition,
                duration: pathStop.segmentBreakDuration,
                stopOrder: pathStop.stopOrder,
                prevDistance: pathStop.prevDistance,
                inSpine: pathStop.inSpine,
                stopId: pathStop.stop.id,
                pathId: pathStop.path.id
            };
        });

        const apiResult = PathStopAPI.createDraft(edition.draftNetwork, newPathStops);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Paragens do Percurso criadas com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateInBulk(edition, pathStops, successCallback, errorCallback) {
        const apiResult = PathStopAPI.updateListDraft(edition.draftNetwork, pathStops);;
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Paragens do Percurso alteradas com sucesso",
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateSpine(edition, pathStopId, isInSpine, successCallback, errorCallback) {
        const apiResult = PathStopAPI.updateSpine(edition.draftNetwork, pathStopId, isInSpine);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateSpineInBulk(edition, pathStopIds, isInSpine, successCallback, errorCallback) {
        const apiResult = PathStopAPI.updateSpineInBulkDraft(edition.draftNetwork, pathStopIds, isInSpine);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    updateComplementaryTerminal(edition, pathStopId, isComplementaryTerminal, successCallback, errorCallback) {
        const apiResult = PathStopAPI.updateComplementaryTerminalDraft(edition.draftNetwork, pathStopId, isComplementaryTerminal);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback();
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, pathStopId, successCallback, errorCallback) {
        const apiResult = PathStopAPI.deleteDraft(edition.draftNetwork, pathStopId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Paragem eliminada com sucesso do Percurso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
